import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { API } from "../../../globals/globals";
import { useGetFileSystemListQuery } from "../../../store/api/deviceConfig/deviceConfigApiSlice";
import { initialState } from "../../../store/helpers/helperInitialState";
import { paginationModelSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { useEffect, useState } from "react";
import { auditFilterFromDateSelector, auditFilterToDateSelector } from "../../../store/filters/audit/selectors";
import dayjs from "dayjs";
import { setSelectedFromDate, setSelectedToDate } from "../../../store/filters/audit/reducers";

export const useFilesData = (fileType = "debuglogs") => {
  const location = useLocation();
  const dispatch = useStoreDispatch();
  const locationPath = location?.pathname.split("/");
  const [sortOrder, setSortOrderFile] = useState("createdAt, desc");
  const pagination = useSelector(paginationModelSelector);

  const selectedFromDate = useSelector(auditFilterFromDateSelector);
  const selectedToDate = useSelector(auditFilterToDateSelector);
  const fromDateMls = dayjs(selectedFromDate).valueOf();
  const toDateMls = dayjs(selectedToDate).valueOf();

  const pageCheck = pagination[fileType] || initialState.pagination;

  const args = {
    filters: `page=${pageCheck.page.toString()}&size=${pageCheck.pageSize.toString()}&fileType=${fileType}&sort=${sortOrder}&fromDate=${fromDateMls}&toDate=${toDateMls}`,
    deviceKey: locationPath[2],
  };

  const { data, isLoading, refetch } = useGetFileSystemListQuery(args, {
    pollingInterval: API.POLLING_INTERVAL,
  });

  const rowData = data?.data || [];
  const noOfRows = data?.totalItems || 0;

  // useEffect(() => {
  //   refetch();
  // }, [refetch]);

  useEffect(() => {
    dispatch(setSelectedFromDate(dayjs().subtract(6, "month")));
    dispatch(setSelectedToDate(dayjs()));
  }, []);

  return {
    rowData,
    noOfRows,
    isLoading,
    sortOrder,
    setSortOrderFile,
  };
};
